<script>
  import { lazyLoad } from "./lazyLoad.js";

  // receive props, but have default fallbacks
  export let src = "picsum.photos/id/201/150/150";
  export let title = "Portrait";
</script>

<img use:lazyLoad={src} alt={title} />
